import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface ContactProps {
  lang: 'uk' | 'ru';
}

const content = {
  uk: {
    heading: "Зв'яжіться зі мною",
    subtext: 'Запишіться на консультацію або поставте запитання. Відповім протягом 24 годин',
    whatsapp: '+38 067 551 7852 (WhatsApp)',
    spain: '+34 625 245 713 (Ісп. номер)',
    location: 'Марбелья, Іспанія',
  },
  ru: {
    heading: 'Свяжитесь со мной',
    subtext: 'Запишитесь на консультацию или задайте вопрос. Отвечу в течение 24 часов',
    whatsapp: '+38 067 551 7852 (WhatsApp)',
    spain: '+34 625 245 713 (Исп. номер)',
    location: 'Марбелья, Испания',
  },
};

export default function Contact({ lang }: ContactProps) {
  const t = content[lang];
  const { ref: headingRef, isVisible: headingVisible } = useScrollAnimation();
  const { ref: contactsRef, isVisible: contactsVisible } = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  return (
    <section id="contact" className="py-16 md:py-24 bg-[#FFF9F4] dark:bg-[#161210]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-xl">
          <div
            ref={headingRef}
            className={`transition-all duration-700 ${headingVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <h2 className="text-3xl md:text-4xl font-light text-[#333333] dark:text-[#EEEEEE] mb-3 md:mb-4">{t.heading}</h2>
            <p className="text-base md:text-lg text-[#666666] dark:text-[#AAAAAA] leading-relaxed mb-8 md:mb-10">{t.subtext}</p>
          </div>

          <div
            ref={contactsRef}
            className={`space-y-4 md:space-y-5 transition-all duration-700 ${contactsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ transitionDelay: '150ms' }}
          >
            <div className="flex items-center gap-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-whatsapp-line text-2xl text-[#7EC8E3]"></i>
              </div>
              <a href="https://wa.me/380675517852" className="text-[15px] md:text-[16px] text-[#555555] dark:text-[#AAAAAA] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer">
                {t.whatsapp}
              </a>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-2xl text-[#7EC8E3]"></i>
              </div>
              <a href="tel:+34625245713" className="text-[15px] md:text-[16px] text-[#555555] dark:text-[#AAAAAA] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer">
                {t.spain}
              </a>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-[#7EC8E3]"></i>
              </div>
              <span className="text-[15px] md:text-[16px] text-[#555555] dark:text-[#AAAAAA]">{t.location}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
